import React from "react";
import { BiInfoCircle } from "react-icons/bi";
import SaveImage from "../../ModalImages/SaveImage";
import SubmitImage from "../../ModalImages/SubmitImage";
import ListImage from "../../ModalImages/ListImage";

function JournalEntryModal() {
  return (
    <div>
      <div class="d-flex justify-content-center align-items-center">
        <span class="modal-btn" data-toggle="modal" data-target="#myModal2">
          <BiInfoCircle />
        </span>
      </div>

      <div
        class="modal right fade my-modal"
        id="myModal2"
        tabindex="-1"
        role="dialog"
        aria-labelledby="myModalLabel2"
      >
        <div className="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title" id="myModalLabel2">
                Journal Entry Info!
              </h4>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div class="modal-body">
              <ul className="modal-ul">
                <li>
                  <h5>
                    <SaveImage />
                    Save
                  </h5>
                  <ul>
                    <li>
                      <ListImage />
                      Users save the voucher and transactions are not affected.
                    </li>
                    <li>
                      <ListImage />
                      Users can update the voucher until the voucher is not
                      submitted.
                    </li>
                  </ul>
                </li>
                <li>
                  <h5>
                    <SubmitImage />
                    Submit
                  </h5>
                  <ul>
                    <li>
                      <ListImage />
                      Transactions run on the basis or transaction type. E.g
                      transaction type specifies which transaction is for Debit
                      and which is for Credit.
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default JournalEntryModal;
